import { SlideType } from '@boltenergy-be/design-system'

export const QUOTES: SlideType[] = [
  {
    id: 'stijn',
    img: { publicId: 'website/producers/stijn', alt: '' },
    quote: 'generator:slider.stijn.text',
    caption: {
      author: 'generator:slider.stijn.author',
      extra: 'generator:slider.extra'
    }
  },
  {
    id: 'francis',
    img: { publicId: 'website/producers/francis', alt: '' },
    quote: 'generator:slider.francis.text',
    caption: {
      author: 'generator:slider.francis.author',
      extra: 'generator:slider.extra'
    }
  },
  {
    id: 'miguel',
    img: { publicId: 'website/producers/miguel', alt: '' },
    quote: 'generator:slider.miguel.text',
    caption: {
      author: 'generator:slider.miguel.author',
      extra: 'generator:slider.extra'
    }
  },
  {
    id: 'kim',
    img: { publicId: 'website/producers/kim', alt: '' },
    quote: 'generator:slider.kim.text',
    caption: {
      author: 'generator:slider.kim.author',
      extra: 'generator:slider.extra'
    }
  }
]
